<template>
  <div class="photos">
    <div class="row">
      <div class="col-12 col-sm-8 text-center text-sm-start">
        <page-title :title="'Foto\'s ' + date" icon="photos"></page-title>
      </div>
      <div class="col-12 col-sm-4 text-center text-sm-end" style="padding-top: 8px; padding-bottom: 8px">
        <router-link to="/photos">
          <button class="btn btn-success me-1">
            Nieuw
          </button>
        </router-link>
        <router-link to="/photos/browse">
          <button class="btn btn-secondary">
            Bladeren
          </button>
        </router-link>
        <span class="d-block d-sm-none" style="padding-top: 6px;"></span>
      </div>
      <div class="col-12">
        <router-view @setDate="setDate($event)"></router-view>
      </div>
    </div>
  </div>
</template>

<script>
import PageTitle from '@/components/Page-Title'
export default {
  name: 'photos',
  components: {
    PageTitle
  },
  data () {
    return {
      date: ''
    }
  },
  methods: {
    setDate (date) {
      if (date.length > 0) {
        this.date = this.$moment(date).format('ddd D MMM')
      } else {
        this.date = date
      }
    }
  }
}
</script>

<style scoped>
</style>
